<template>
    <div>

      <report-window endpoint="/reports/accounts_summary" :fields="fields" :title="title" :headers="headers"
      :templates="templates" :columnsClasses="columnsClasses"></report-window>

    </div>
</template>

<script>
import '@/css/app.css';

import ReportWindow from '@/components/tools/ReportWindow'
import { mapState } from 'vuex';
var moment = require('moment');
export default {
  name: 'accountssummary',
  components: {

    ReportWindow,
  },
  computed: {
    ...mapState({
        user: state => state.user,
    }),
  },
  data () {
    return {
        fields: [
        {name: 'FromDate', editor: 'date', label: 'Desde', defValue: moment(new Date()).format("YYYY-MM-DD")
            , required: true, columns: 1},
        {name: 'ToDate', editor: 'date', label: 'Hasta', defValue:  moment(new Date()).format("YYYY-MM-DD")
            , required: true, columns: 1},
        {name: 'AccountNr', label: 'Cuenta', columns: 1},
        {name: 'Mode', label: 'Expandir', editor: 'select', defValue: '0',
            options: [
                {value: '0', label: 'No'},
                {value: '1', label: 'Si'},
                {value: '2', label: 'Detalle de Tickets'},
                ]},
         ],

        title: 'Cuenta Corriente',
        headers: {AccountNumber: 'Cuenta',
            CollectedCurrencyCode: 'Moneda',
            Fare: 'Tarifa',
            Extra: 'Extras',
            Amount: 'Monto'},
        templates: [
            {name: 'Amount', callback (row) {
                    if (!row.Amount) return app.numberFormat(0);
                    return app.numberFormat(parseFloat(row.Amount));
                }
            },
            {name: 'Fare', callback (row) {
                    if (!row.Fare) return app.numberFormat(0);
                    return app.numberFormat(parseFloat(row.Fare));
                }
            },
            {name: 'XR', callback (row) {
                    if (!row.XR) return app.numberFormat(0);
                    return app.numberFormat(parseFloat(row.XR));
                }
            },
            {name: 'DL', callback (row) {
                    if (!row.DL) return app.numberFormat(0);
                    return app.numberFormat(parseFloat(row.DL));
                }
            },
            {name: 'QN', callback (row) {
                    if (!row.QN) return app.numberFormat(0);
                    return app.numberFormat(parseFloat(row.QN));
                }
            },
            {name: 'TQ', callback (row) {
                    if (!row.TQ) return app.numberFormat(0);
                    return app.numberFormat(parseFloat(row.TQ));
                }
            },
            {name: 'Extra', callback (row) {
                    if (!row.Extra) return app.numberFormat(0);
                    return app.numberFormat(parseFloat(row.Extra));
                }
            },
        ],
        columnsClasses: {Amount: 'text-right'},

    }
  },
}
</script>

